import commsIconOnlyUrl from '../assets/comms_icon_only.svg';
import commsLogoDarkUrl from '../assets/comms_logo_dark_transparent.svg';
import commsLogoLightUrl from '../assets/comms_logo_light_transparent.svg';

type Tone = 'dark' | 'light';
type Variant = 'icon' | 'wordmark';

interface Props {
  tone: Tone;
  variant?: Variant;
  className?: string;
}

export function BrandLogo({ tone, variant = 'wordmark', className }: Props) {
  const src =
    variant === 'icon' ? commsIconOnlyUrl : tone === 'dark' ? commsLogoDarkUrl : commsLogoLightUrl;
  const alt = variant === 'icon' ? 'comms icon' : 'comms';

  return <img src={src} alt={alt} className={className} draggable={false} />;
}
